import { jsx } from 'react/jsx-runtime';
import { clsx } from '@flex-design-system/ve-presets';
import { composeEventHandlers } from '@radix-ui/primitive';
import { Primitive } from '@radix-ui/react-primitive';
import { forwardRef } from 'react';
import { useFileUploadContext } from '../../context.mjs';
import { getFilesFromEvent } from '../../utils/getFilesFromEvent.mjs';
import { dropZone } from './drop-zone.vanilla.mjs';

const FileUploadDropZone = forwardRef(
  ({
    className: classNameFromProps,
    onDrop,
    onDragEnter,
    onDragLeave,
    onDragOver,
    ...props
  }, forwardedRef) => {
    const { disabled, droppable, multiple, onDraggingChange, onFilesChange } = useFileUploadContext("FileUpload.DropZone");
    const className = clsx(dropZone, classNameFromProps);
    const canUseDropZone = !disabled && droppable;
    const handleDrop = composeEventHandlers(onDrop, (event) => {
      if (!canUseDropZone) {
        return;
      }
      event.preventDefault();
      const filesFromEvent = getFilesFromEvent(event);
      onFilesChange(multiple ? filesFromEvent : filesFromEvent.slice(0, 1));
      onDraggingChange(false);
    });
    const handleDragEnter = composeEventHandlers(onDragEnter, (event) => {
      if (!canUseDropZone) {
        return;
      }
      event.preventDefault();
      onDraggingChange(true);
    });
    const handleDragOver = composeEventHandlers(onDragOver, (event) => {
      if (!canUseDropZone) {
        return;
      }
      event.preventDefault();
      onDraggingChange(true);
    });
    const handleDragLeave = composeEventHandlers(onDragLeave, (event) => {
      if (!canUseDropZone) {
        return;
      }
      event.preventDefault();
      const { currentTarget, relatedTarget } = event;
      if (relatedTarget !== null && relatedTarget instanceof HTMLElement && currentTarget.contains(relatedTarget)) {
        return;
      }
      onDraggingChange(false);
    });
    return /* @__PURE__ */ jsx(
      Primitive.div,
      {
        "data-scope": "file-upload",
        "data-part": "drop-zone",
        className,
        onDragEnter: handleDragEnter,
        onDragLeave: handleDragLeave,
        onDragOver: handleDragOver,
        onDrop: handleDrop,
        ref: forwardedRef,
        ...props
      }
    );
  }
);
FileUploadDropZone.displayName = "FileUpload.DropZone";

export { FileUploadDropZone };
//# sourceMappingURL=DropZone.mjs.map
